import { render, staticRenderFns } from "./error401.vue?vue&type=template&id=e77210f2&scoped=true"
import script from "./error401.vue?vue&type=script&lang=js"
export * from "./error401.vue?vue&type=script&lang=js"
import style0 from "./error401.vue?vue&type=style&index=0&id=e77210f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77210f2",
  null
  
)

export default component.exports